export const FEDERAL = 1;
export const LOCAL = 2;
export const AMBOS = 3;

export const ambitos = [
  { key: 1, label: 'Federal', value: 1 },
  { key: 2, label: 'Local', value: 2 },
  { key: 3, label: 'Ambos', value: 3 }
];
